import React from 'react';
import '../../App.css';

export default function SignUp() {
  return <h1 className='sign-up'><a className='ankor' href='https://crossy.netlify.app/' target='_blank'>Direct DEMO</a></h1>;

}

  

